import { render } from "./DataType.vue?vue&type=template&id=2dbf0070"
import script from "./DataType.vue?vue&type=script&lang=js"
export * from "./DataType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__